// FOLLOWUP API
import Request from '../base'
export default {
    save (options) {
        return Request.post('/ebermain/mainapi/followup/followup/save', options)
    },
    delete (options) {
        return Request.post('/ebermain/mainapi/followup/followup/delete', options)
    },
    list (options) {
        options.sort = options.sort || 'time'
        options.order = options.order || 'ASC'
        return Request.post('/ebermain/mainapi/followup/followup/list', options)
    },
    find (pagination, options) {
        if (!pagination) {
            pagination = {}
        }
        if (!pagination.sort) {
            pagination.sort = 'time'
        }
        if (!pagination.order) {
            pagination.order = 'ASC'
        }
        return Request.post('/ebermain/mainapi/followup/followup/find', Request.paginationBody(options, pagination))
    },
    export (options) {
        options.sort = options.sort || 'time'
        options.order = options.order || 'ASC'
        return Request.download('/ebermain/mainapi/followup/followup/export', options)
    }
}
